import { Skeleton } from "@/components/ui/skeleton"

export function CollectorLoader() {
  return (
    <tr className="relative">
      <td className="py-4 pl-4 pr-8 sm:pl-6 lg:pl-8 w-9/12">
        <div className="flex items-center gap-x-4">
          {/* Avatar skeleton */}
          <Skeleton className="h-8 w-8 rounded-full border border-slate-200 dark:border-slate-500" />

          {/* Name/Wallet skeleton - single line */}
          <Skeleton className="h-5 w-48 sm:w-60" />

          {/* Subscriber badge skeleton */}
          <Skeleton className="h-6 w-20 rounded-md" />
        </div>
      </td>
      <td className="hidden py-4 pl-0 pr-4 text-right text-sm leading-6 text-muted-foreground sm:table-cell sm:pr-6 lg:pr-8 w-3/12">
        <Skeleton className="h-4 w-8 ml-auto" />
      </td>
    </tr>
  )
}
